import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { API, CRUD } from '../../shared/constants';
import { HttpClientService } from '../../shared/http.client.service';
import { ExceptionService } from '../../core/exception.service';

@Injectable()
export class TableService {
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(
    private exceptionService: ExceptionService,
    private _httpClientService: HttpClientService
  ) { }

  /**
  *  Get news list data
  */
  getNewsHeaders() {
    return [
      {
        'title': 'Título',
        'attr': 'title',
        'orderBy': false
      },
      {
        'title': 'Data',
        'attr': 'creationDate',
        'orderBy': true
      },
      {
        'title': 'Status',
        'attr': 'status',
        'orderBy': false
      }
    ];
  }

  getNews(query?: string) {
    return this._httpClientService
      .get(API.ENDPOINT.NEWS+ CRUD.LIST+ query)
      .toPromise()
      .then(response => response.json().news)
      .catch(this.exceptionService.catchBadResponse);
  }

  private handleError(error: any):  Promise<any> {
      return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/table/table.service.ts